import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({
	providedIn: 'root',
})
export class MsDialogDynamicService {
	_configDefault: any = {
		focusOnShow: false,
		width: '50vw',
		closable: true,
		modal: true,
		breakpoints: {
			'960px': '75vw',
			'640px': '90vw',
		},
	};

	private ref: DynamicDialogRef | undefined;

	constructor(private _dialogService: DialogService) {}

	show(_header: string, _data: any, _component: any, _configs?: any) {
		let __configs = { ...this._configDefault, header: _header, data: _data };
		if (_configs) {
			__configs = _configs;
		}
		this.ref = this._dialogService.open(_component, __configs);
		this.ref.onClose.subscribe((data: any) => {});
	}

	close(): void {
		if (this.ref) {
			this.ref.close();
		}
	}
}
